<template>
  <div class="circle-color-picker" :aria-label="name" :title="name">
    <PopoverMenu v-model:open="open" size="fit-content" placement="bottom">
      <template #trigger>
        <ColorPickerButton :circle-icon="circleIcon" :color="modelValue" data-test-id="color-picker-button" />
      </template>

      <template #popover>
        <PopoverMenuSection>
          <ColorPicker
            :colors="colors"
            :no-color-allowed="noColorAllowed"
            :extra-color-sets="extraColorSets"
            :model-value="modelValue"
            @update:model-value="handleChange"
          />
        </PopoverMenuSection>
      </template>
    </PopoverMenu>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { Color, ColorSet } from '@/types';
import { colorArray } from '@common/codecolors/codecolors';
import ColorPickerButton from '@components/common/ColorPickerButton.vue';

export default defineComponent({
  name: 'CircleColorPicker',

  emits: {
    'update:modelValue': null,
  },

  components: {
    ColorPickerButton,
  },

  props: {
    circleIcon: {
      type: Boolean,
      default: false,
    },

    colors: {
      type: Array as PropType<Array<Color>>,
      default: () => colorArray,
    },

    extraColorSets: {
      type: Array as PropType<Array<ColorSet>>,
      default: (): Array<ColorSet> => [],
    },

    modelValue: {
      type: String,
      required: false,
      default: null,
    },

    noColorAllowed: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      open: false,
    };
  },

  computed: {
    name(): string {
      const colorMatch = this.colors.find((color) => color.rgb === this.modelValue);

      // Guard against color mismatch between master list and database
      return (colorMatch && colorMatch.name) || '';
    },
  },

  methods: {
    handleChange(color, $event) {
      this.$emit('update:modelValue', color, $event);
      this.open = false;
    },
  },
});
</script>
